import React, { PropsWithChildren } from 'react';
import styled, { keyframes } from 'styled-components';
import check from '@iconify/icons-entypo/check';
import { Icon } from '@iconify/react';
import { Flex, Text, Image } from 'rebass/styled-components';
import doctorIcon from '../static/logoloader2.gif';

const blink = keyframes`
  50% {color: transparent;}
`;

export const Dot = styled.span`
  animation: 1s ${blink} infinite;
  &:nth-child(1) {
    animation-delay: 0ms;
  }
  &:nth-child(2) {
    animation-delay: 250ms;
  }
  &:nth-child(3) {
    animation-delay: 500ms;
  }
`;

const CompleteCheckMark = styled.div<{ width?: number, height?: number }>`
  display: flex;
  border-radius: 50%;
  background-color: #354e79;
  height: ${props => (props.height ? `${props.height}px` : '68px')};
  width: ${props => (props.width ? `${props.width}px` : '68px')};
  justify-content: center;
  align-items: center;
`;

export const PleaseWait: React.FC<{ text?: string, style?: React.CSSProperties } & PropsWithChildren> = ({ 
  text = 'Please Wait', 
  style, 
  children }) => {
  return (
    <Flex flexDirection="column" alignItems="center" style={style}>
      <Image src={doctorIcon} width='50px' height='50px' />
      {text && text !== ' ' ? (
        <Text mt="24px" textAlign="center">
          {text}
          <Dot>.</Dot>
          <Dot>.</Dot>
          <Dot>.</Dot>
        </Text>
      ) : null}
      {children}
    </Flex>
  );
};

export const SubscriptionRegistrationComplete: React.FC<{ text?: string, style: React.CSSProperties } & PropsWithChildren> = ({ text, style, children }) => {
  return (
    <Flex flexDirection="column" alignItems="center" style={style}>
      <CompleteCheckMark>
        <Icon
          icon={check}
          style={{
            color: 'white',
            fontSize: '32px',
            alignSelf: 'center',
          }}
        />
      </CompleteCheckMark>
      <Text
        mt="36px"
        style={{ fontWeight: 600, fontSize: '24px' }}
        textAlign="center"
      >
        Welcome to your Paloma Health membership
      </Text>
      <Text mt="24px" mb="36px" textAlign="center">
        {text || 'Press Continue to finalize your visit booking'}
      </Text>
      {children}
    </Flex>
  );
};

export default PleaseWait;
